// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"48":"f7d6f6","96":"bdd3ec","687":"f4e416","763":"030510","922":"84c9af"}[chunkId] + ".css";
};